/**
 * Created by 易晓峰(林异)<yxf@106063@alibaba-inc.com> on 16/7/12.
 */
import CookieInfo from './cookie-info';

export default CookieInfo;


// WEBPACK FOOTER //
// ./node_modules/@alife/mscc-cookie/src/index.js